import { render } from "./NavigationLink.vue?vue&type=template&id=2e3c8364"
const script = {}
script.render = render

export default script